"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TravelAgentSignUpCategory = exports.TravelAgentCategory = void 0;
var TravelAgentCategory;
(function (TravelAgentCategory) {
    TravelAgentCategory["DITA"] = "DITA";
    TravelAgentCategory["CITA"] = "CITA";
    TravelAgentCategory["TAHAD"] = "TAHAD";
    TravelAgentCategory["TAHAC"] = "TAHAC";
    TravelAgentCategory["INTRAIL"] = "INTRAIL";
})(TravelAgentCategory || (exports.TravelAgentCategory = TravelAgentCategory = {}));
var TravelAgentSignUpCategory;
(function (TravelAgentSignUpCategory) {
    TravelAgentSignUpCategory["DITA"] = "DITA";
    TravelAgentSignUpCategory["CITA"] = "CITA";
    TravelAgentSignUpCategory["TAHAC"] = "TAHAC";
    TravelAgentSignUpCategory["TAHAD"] = "TAHAD";
})(TravelAgentSignUpCategory || (exports.TravelAgentSignUpCategory = TravelAgentSignUpCategory = {}));
//# sourceMappingURL=travel-agent-category.enum.js.map